jQuery(document).ready(function(){
    jQuery('.wp-block-ressources-slider').each(function(){
        let currentSlider = jQuery(this);
        new RessourcesSlider(currentSlider);
    })
})

class RessourcesSlider {
    constructor(dom){
        this.dom = dom;
        this.sliderClock = null;
        this.activeSlider = 1;
        this.termsContainer = this.dom.find('.ressources-slider-terms');
        this.duration = this.dom.data('duration') ? parseInt(this.dom.data('duration'))*10 : 3000;
        this.startSlider(this);
        this.initTerm(this);
        this.initNavigation(this);
    }
    startSlider(instance){
        instance.dom.find('.ressources-slider-slider').addClass('slider-active');
        instance.sliderClock = setInterval(function(){instance.nextSlide(instance)}, instance.duration);
        instance.setActiveSlider(instance);
    }
    resetClock(instance){
        clearInterval(instance.sliderClock);
        instance.sliderClock=null;
        instance.sliderClock = setInterval(function(){instance.nextSlide(instance)}, instance.duration);
    }
    stopSlider(instance){
        clearInterval(instance.sliderClock);
        instance.sliderClock=null;
        instance.dom.find('.ressources-slider-slider').removeClass('slider-active');
    }
    nextSlide(instance){
        let numberOfSlide = instance.dom.find('.ressources-slider-slider-slide').length;
        instance.activeSlider = instance.activeSlider>=numberOfSlide ? 1 : instance.activeSlider+1;
        instance.setActiveSlider(instance);
    }
    prevSlide(instance){
        instance.activeSlider = instance.activeSlider<=1 ? instance.dom.find('.ressources-slider-slider-slide').length : instance.activeSlider-1;
        instance.setActiveSlider(instance);
    }
    initNavigation(instance){
        instance.dom.find('.slider-next').off('click');
        instance.dom.find('.slider-prev').off('click');
        instance.dom.find('.slider-next').on('click', function(){
            instance.resetClock(instance);
            instance.nextSlide(instance);
        });
        instance.dom.find('.slider-prev').on('click', function(){
            instance.resetClock(instance);
            instance.prevSlide(instance);
        });
    }
    initTerm(instance){
        instance.termsContainer.find('>span').click(function(){
            let clickedSpan = jQuery(this);
            if(!clickedSpan.hasClass('active')){
                let slideFound = false;
                instance.dom.find('.ressources-slider-slider-slide').each(function(index, item){
                    if(!slideFound && jQuery(item).data('tag')===clickedSpan.data('tag')){
                        instance.activeSlider = index+1;
                        slideFound = true;
                    }
                });
                instance.resetClock(instance);
                instance.setActiveSlider(instance);
            }
        })
    }
    setActiveSlider(instance){
        let oldActiveSlider = instance.dom.find('.ressources-slider-slider-slide.active');
        let activeSlider = instance.dom.find('.ressources-slider-slider-slide:nth-child('+(instance.activeSlider)+')');
        instance.termsContainer.find('>span.active').removeClass('active');
        instance.termsContainer.find('>span[data-tag="'+activeSlider.data('tag')+'"]').addClass('active');
        oldActiveSlider.removeClass('active');
        activeSlider.addClass('active');
    }

}